<section class="content">
  <div class="container-fluid">
    <div class="row">

      <div class="row mt-3 align-items-center justify-content-between">

        <!-- SEARCH -->
        <div class="col-lg-6 col-md-8 col-12 mb-2 mb-lg-0"> 
          <div class="form-floating"> 
          <input type="search" class="form-control" id="productSearch" placeholder="Search" [(ngModel)]="searchText" (input)="onSearchChange($event)" autocomplete="off"> 
          <label for="productSearch" class="text-secondary"> Search Product / Barcode / Size </label> 
        </div>
        </div>

        <!-- DOWNLOAD BUTTONS -->
        <div class="col-lg-4 col-md-4 col-12 d-flex justify-content-lg-end gap-2">

          <!-- PDF -->
          <button class="btn btn-danger w-100 w-lg-auto" (click)="downloadPdf()">
            <i class="fas fa-file-pdf me-2"></i>
            PDF
          </button>

          <!-- EXCEL -->
          <button class="btn btn-success w-100 w-lg-auto" (click)="downloadExcel()">
            <i class="fas fa-file-excel me-2"></i>
            Excel
          </button>

        </div>

      </div>
      <div class="row mt-3">
        <div class="table-style table-responsive table-bordered">
          <table class="table table-head-fixed text-nowrap text-center">
            <thead>
              <tr class="sticky-top">
                <th>S.No</th>
                <th>Product Name</th>
                <th>Barcode Number</th>
                <th>Freeze</th>
                <th>Unfreeze</th>
                <th>View Image</th>
                <th>SRP (₹)</th>
                <th>Size</th>
                <th>Total Quantity</th>
                <th>Current Quantity</th>
                <th>Free Stage Quantity</th>
              </tr>
            </thead>
            <tbody class="text-center" *ngIf="filteredVariantDetails.length > 0; else noDataFound">
              <tr *ngFor=" let item of filteredVariantDetails; let i = index; trackBy: trackByVariantId">
                <td>{{ i + 1 }}</td>
                <td (click)="openItemsModal(item?.productId)">{{ item?.productName || '-' }}</td>
                <td (click)="openItemsModal(item?.productId)">{{ item?.barcodeNumber || '-' }}</td>
                <td>
                  <button class="btn btn-danger btn-sm" (click)="updateFreezeStage(item,'Freeze')">
                    Freeze
                  </button>
                </td>
                <td>
                  <button class="btn btn-success btn-sm" (click)="updateFreezeStage(item,'Unfreeze')">
                    Unfreeze
                  </button>
                </td>
                <td>
                  <button class="btn btn-secondary btn-sm" (click)="openImageModal(item)">
                    View
                  </button>
                </td>
                <td>{{ item?.productSrp || 0 | currency:'INR':'symbol':'1.2-2' }}</td>
                <td>{{ item?.size || '-' }}</td>
                <td>{{ item?.varientQuantity || 0 }}</td>
                <td>{{ item?.availableStock || 0 }}</td>

                <td>
                  {{item?.reservedQuantity || 0}}
                </td>

              </tr>
            </tbody>
            <ng-template #noDataFound>
              <tr class="text-center ubuntu-bold h6 text-danger">
                <td colspan="12">Data Not Found</td>
              </tr>
            </ng-template>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- IMAGE VIEW MODAL -->
<div class="modal fade" id="imagePreviewModal" tabindex="-1" aria-hidden="true">

  <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
    <div class="modal-content">

      <!-- HEADER -->
      <div class="modal-header">
        <h5 class="modal-title">
          {{ selectedVariant?.productName }} - Images
        </h5>

        <button type="button" class="btn-close" data-bs-dismiss="modal">
        </button>
      </div>

      <!-- BODY -->
      <div class="modal-body">

        <!-- NO IMAGE -->
        <div *ngIf="this.getImageId == 0 || this.getImageId == null" class="text-center text-muted">
          <p>No Images Available</p>
          <img src="assets/img/my-1.jpg" class="img-fluid default-img">
        </div>

        <!-- IMAGE LIST -->
        <div class="row g-3  d-flex justify-content-center" *ngIf="getImageId != 0">

          <div class="col-6 col-md-4 col-lg-3">
            <div class="image-card d-flex justify-content-center align-items-center w-100">
              <img [src]="getImageById(getImageId)" class="img-fluid rounded shadow-sm preview-img">
            </div>
          </div>

        </div>

      </div>

    </div>
  </div>
</div>


<div class="custom-backdrop" *ngIf="isItemsModalOpen">

  <!-- ===== MODAL ===== -->
  <div class="custom-modal" (click)="$event.stopPropagation()">

    <div class="modal-header">
      <h5 class="modal-title">
        Product Name - {{ getAllVariantDetailsByProductId[0]?.productName }}
      </h5>

      <button class="btn-close" (click)="closeItemsModal()"></button>
    </div>

    <div class="modal-body">

      <!-- <table class="table table-bordered text-center">
        <thead class="table-light">
          <tr>
            <th>S.No</th>
            <th>Product Name</th>
            <th>Barcode Number</th>
            <th>SRP (₹)</th>
            <th>Size</th>
            <th>Total Quantity</th>
            <th>Current Quantity</th>
            <th>Free Stage Quantity</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of getAllVariantDetailsByProductId; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item?.productName }}</td>
            <td>{{ item?.barcodeNumber }}</td>
            <td>{{ item?.productSrp || 0 | currency:'INR':'symbol':'1.2-2' }}</td>
            <td>{{ item?.size || '-' }}</td>
            <td>{{ item?.varientQuantity || 0 }}</td>
            <td>{{ item?.availableStock || 0 }}</td>

            <td>
              {{item?.reservedQuantity || 0}}
            </td>
          </tr>
        </tbody>
      </table> -->

      <div class="d-flex flex-wrap justify-content-center gap-3 mb-4"> 
        <span *ngFor="let item of getAllVariantDetailsByProductId" class="badge bg-light text-dark border border-primary rounded-pill px-3 py-2 fs-6 fw-semibold"> 
        {{ item?.barcodeNumber || '-' }} </span> 
      </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeItemsModal()">
        Close
      </button>
    </div>

  </div>
</div>